import { actionCreator } from 'utils';
import * as CustomerTypes from '../types/customerTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    listing: {},
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
        turnover: {
            loading: false,
            data2Months: null,
            dataTotal: null,
            error: false,
            success: false,
        },
    },
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        customerID: '',
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        vat: '',
        status: undefined,
        lang: undefined,
        customer_type: undefined,
        b2b_login: undefined,
        acountManager: null,
    },
    contacts: {
        loading: false,
        error: false,
        offset: 0,
        limit: 10,
        listing: null,
        filters: {
            status: null,
        },
    },
    addContact: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    editViewContact: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    addresses: {
        add: {
            loading: false,
            error: false,
            success: false,
        },
        edit: {
            loading: false,
            error: false,
            success: false,
        },
        shipping: {
            loading: false,
            error: false,
            offset: 0,
            limit: 10,
            listing: null,
            filters: {
                name: '',
                company: '',
                email: '',
                address_status: '',
            },
        },
        billing: {
            loading: false,
            error: false,
            offset: 0,
            limit: 10,
            listing: null,
            filters: {
                name: '',
                company: '',
                vat_number: '',
                address_status: '',
            },
        },
    },
    orders: {
        loading: false,
        error: false,
        offset: 0,
        limit: 10,
        sort: {
            key: 'created_at',
            type: 'desc',
        },
        filters: {
            status: undefined,
        },
        listing: null,
        neededData: {
            productGroups: [],
            configurations: [],
        },
    },
    quotes: {
        loading: false,
        error: false,
        offset: 0,
        limit: 10,
        sort: {
            key: 'created_at',
            type: 'desc',
        },
        filters: {
            loading: false,
            status: '',
            title: '',
            contact: '',
            sender: '',
            start_date: [],
            end_date: [],
        },
        listing: null,
        contact: null,
        sender: null,
    },
    finance: {
        add: {
            loading: false,
            error: false,
            success: false,
        },
        invoices: {
            loading: false,
            error: false,
            offset: 0,
            limit: 10,
            listing: null,
            filters: {
                id: '',
                orderId: '',
                vat: '',
                reference: '',
                ogm: '',
                status: undefined,
                creationDate: [],
                paymentDelay: [],
            },
            download: {
                loading: false,
                error: false,
                success: false,
            },
            export: {
                loading: false,
                error: false,
                success: false,
            },
        },
        proforma: {
            loading: false,
            error: false,
            offset: 0,
            limit: 10,
            listing: null,
            filters: {
                id: '',
                orderId: '',
                vat: '',
                reference: '',
                ogm: '',
                billing: undefined,
                creationDate: [],
                paymentDelay: [],
            },
            download: {
                loading: false,
                error: false,
                success: false,
            },
            regenerate: {
                loading: [],
                error: false,
            },
            export: {
                loading: false,
                error: false,
                success: false,
            },
            checked: [],
            selected: [],
            proforma_ids: [],
        },
        billingAddresses: {
            loading: false,
            error: false,
            listing: null,
        },
        details: {
            loading: false,
            error: false,
            listing: null,
        },
        setCreditNoteInvoice: {
            loading: false,
            error: false,
            success: false,
        },
    },
    tab: 'orders',
};

export default function (state = initState, action) {
    switch (action.type) {
    case CustomerTypes.LOAD_CUSTOMERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case CustomerTypes.SET_CUSTOMER_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case CustomerTypes.RESET_CUSTOMER_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case actionCreator(CustomerTypes.SET_CUSTOMER_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case CustomerTypes.SET_CUSTOMER_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case CustomerTypes.SET_CUSTOMER_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case CustomerTypes.ADD_NEW_CUSTOMER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_CUSTOMER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_CUSTOMER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case CustomerTypes.LOAD_EDITABLE_CUSTOMER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_EDITABLE_CUSTOMER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_EDITABLE_CUSTOMER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case CustomerTypes.SET_EMPTY_EDITABLE_CUSTOMER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
                turnover: {
                    loading: false,
                    data: null,
                    error: false,
                    success: false,
                },
            }),
        });

    case CustomerTypes.EDIT_CUSTOMER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CustomerTypes.EDIT_CUSTOMER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(CustomerTypes.EDIT_CUSTOMER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case CustomerTypes.LOAD_CONTACTS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(CustomerTypes.LOAD_CONTACTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            contacts: {
                ...state.contacts,
                listing: action.data,
            },
        });

    case actionCreator(CustomerTypes.LOAD_CONTACTS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case CustomerTypes.SET_CONTACT_FILTER:
        return Object.assign({}, state, {
            contacts: {
                ...state.contacts,
                filters: {
                    ...state.contacts.filters,
                    [action.key]: action.value,
                },
            },
        });

    case CustomerTypes.SET_CONTACT_PAGINATION:
        return Object.assign({}, state, {
            contacts: Object.assign({}, state.contacts, {
                ...state.contacts,
                [action.key]: action.pagination,
            }),
        });

    case CustomerTypes.ADD_NEW_CONTACT:
        return Object.assign({}, state, {
            addContact: Object.assign({}, state.addContact, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_CONTACT, 'res'):
        return Object.assign({}, state, {
            addContact: Object.assign({}, state.addContact, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_CONTACT, 'err'):
        return Object.assign({}, state, {
            addContact: Object.assign({}, state.addContact, {
                loading: false,
                error: action.error,
            }),
        });

    case CustomerTypes.EDIT_CONTACT:
        return Object.assign({}, state, {
            editViewContact: Object.assign({}, state.editViewContact, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CustomerTypes.EDIT_CONTACT, 'res'):
        return Object.assign({}, state, {
            editViewContact: Object.assign({}, state.editViewContact, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(CustomerTypes.EDIT_CONTACT, 'err'):
        return Object.assign({}, state, {
            editViewContact: Object.assign({}, state.editViewContact, {
                loading: false,
                error: true,
            }),
        });

    case CustomerTypes.SET_EMPTY_EDITABLE_CONTACT:
        return Object.assign({}, state, {
            editViewContact: Object.assign({}, state.editViewContact, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case CustomerTypes.ADD_NEW_ADDRESS:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                add: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_ADDRESS, 'res'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                add: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_ADDRESS, 'err'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                add: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case CustomerTypes.LOAD_SHIPPING_ADDRESSES:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                shipping: {
                    ...state.addresses.shipping,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_SHIPPING_ADDRESSES, 'res'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                shipping: {
                    ...state.addresses.shipping,
                    loading: false,
                    listing: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_SHIPPING_ADDRESSES, 'err'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                shipping: {
                    ...state.addresses.shipping,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.LOAD_BILLING_ADDRESSES:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                billing: {
                    ...state.addresses.billing,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_BILLING_ADDRESSES, 'res'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                billing: {
                    ...state.addresses.billing,
                    loading: false,
                    listing: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_BILLING_ADDRESSES, 'err'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                billing: {
                    ...state.addresses.billing,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.SET_SHIPPING_ADDRESS_FILTER:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                shipping: {
                    ...state.addresses.shipping,
                    loading: true,
                    filters: {
                        ...state.addresses.shipping.filters,
                        [action.key]: action.value,
                    },
                },
            }),
        });

    case CustomerTypes.RESET_SHIPPING_ADDRESS_FILTERS:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                shipping: {
                    ...state.addresses.shipping,
                    filters: initState.addresses.shipping.filters,
                },
            }),
        });

    case CustomerTypes.SET_SHIPPING_ADDRESS_PAGINATION:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                shipping: {
                    ...state.addresses.shipping,
                    [action.key]: action.pagination,
                },
            }),
        });


    case CustomerTypes.SET_BILLING_ADDRESS_FILTER:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                billing: {
                    ...state.addresses.billing,
                    loading: true,
                    filters: {
                        ...state.addresses.billing.filters,
                        [action.key]: action.value,
                    },
                },
            }),
        });

    case CustomerTypes.RESET_BILLING_ADDRESS_FILTERS:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                billing: {
                    ...state.addresses.billing,
                    filters: initState.addresses.billing.filters,
                },
            }),
        });

    case CustomerTypes.SET_BILLING_ADDRESS_PAGINATION:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                billing: {
                    ...state.addresses.billing,
                    [action.key]: action.pagination,
                },
            }),
        });

    case CustomerTypes.EDIT_ADDRESS:
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                edit: {
                    ...state.addresses.edit,
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(CustomerTypes.EDIT_ADDRESS, 'res'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                edit: {
                    ...state.addresses.edit,
                    loading: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(CustomerTypes.EDIT_ADDRESS, 'err'):
        return Object.assign({}, state, {
            addresses: Object.assign({}, state.addresses, {
                edit: {
                    ...state.addresses.edit,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.LOAD_CUSTOMER_ORDERS:
        return Object.assign({}, state, {
            orders: Object.assign({}, state.orders, {
                ...state.orders,
                loading: true,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_ORDERS, 'res'):
        return Object.assign({}, state, {
            orders: Object.assign({}, state.orders, {
                ...state.orders,
                loading: false,
                listing: action.data,
                neededData: {
                    ...state.orders.neededData,
                    ...action.neededData,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_ORDERS, 'err'):
        return Object.assign({}, state, {
            orders: Object.assign({}, state.orders, {
                ...state.orders,
                loading: false,
                error: true,
            }),
        });

    case CustomerTypes.SET_CUSTOMER_ORDERS_FILTER:
        return Object.assign({}, state, {
            orders: {
                ...state.orders,
                loading: true,
                filters: {
                    ...state.orders.filters,
                    [action.key]: action.value,
                },
            },
        });

    case actionCreator(CustomerTypes.SET_CUSTOMER_ORDERS_FILTER, 'res'):
        return Object.assign({}, state, {
            orders: {
                ...state.orders,
                loading: false,
                listing: action.data,
            },
        });

    case CustomerTypes.SET_CUSTOMER_ORDERS_PAGINATION:
        return Object.assign({}, state, {
            orders: {
                ...state.orders,
                [action.key]: action.pagination,
            },
        });

    case CustomerTypes.SET_CUSTOMER_ORDERS_SORT:
        return Object.assign({}, state, {
            orders: {
                ...state.orders,
                sort: action.sort,
            },
        });

    case CustomerTypes.RESET_CUSTOMER_ORDERS_FILTERS:
        return Object.assign({}, state, {
            orders: {
                ...state.orders,
                filters: initState.orders.filters,
            },
        });

    case CustomerTypes.LOAD_CUSTOMER_QUOTES:
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                loading: true,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES, 'res'):
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES, 'err'):
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                loading: false,
                error: true,
            }),
        });

    case CustomerTypes.SET_CUSTOMER_QUOTES_FILTER:
        return Object.assign({}, state, {
            quotes: {
                ...state.quotes,
                loading: true,
                filters: {
                    ...state.quotes.filters,
                    [action.key]: action.value,
                },
            },
        });

    case actionCreator(CustomerTypes.SET_CUSTOMER_QUOTES_FILTER, 'res'):
        return Object.assign({}, state, {
            quotes: {
                ...state.quotes,
                loading: false,
                listing: action.data,
            },
        });

    case CustomerTypes.SET_CUSTOMER_QUOTES_PAGINATION:
        return Object.assign({}, state, {
            quotes: {
                ...state.quotes,
                [action.key]: action.pagination,
            },
        });

    case CustomerTypes.SET_CUSTOMER_QUOTES_SORT:
        return Object.assign({}, state, {
            quotes: {
                ...state.quotes,
                sort: action.sort,
            },
        });

    case CustomerTypes.RESET_CUSTOMER_QUOTES_FILTERS:
        return Object.assign({}, state, {
            quotes: {
                ...state.quotes,
                filters: initState.quotes.filters,
            },
        });

    case CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT:
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                filters: {
                    ...state.quotes.filters,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT, 'res'):
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                contact: action.data,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT, 'err'):
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                error: true,
                filters: {
                    ...state.quotes.filters,
                    loading: false,
                },
            }),
        });

    case CustomerTypes.LOAD_CUSTOMER_QUOTES_SENDER:
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_SENDER, 'res'):
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                sender: action.data,
                filters: {
                    ...state.quotes.filters,
                    loading: false,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_QUOTES_SENDER, 'err'):
        return Object.assign({}, state, {
            quotes: Object.assign({}, state.quotes, {
                ...state.quotes,
                error: true,
                filters: {
                    loading: false,
                },
            }),
        });

    case CustomerTypes.SET_CUSTOMER_TAB:
        return Object.assign({}, state, {
            tab: action.tab,
        });

    case CustomerTypes.ADD_NEW_INVOICE:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                add: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_INVOICE, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                add: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(CustomerTypes.ADD_NEW_INVOICE, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                add: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case CustomerTypes.LOAD_CUSTOMER_INVOICES:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                invoices: {
                    ...state.finance.invoices,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_INVOICES, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                invoices: {
                    ...state.finance.invoices,
                    loading: false,
                    listing: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_INVOICES, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                invoices: {
                    ...state.finance.invoices,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.LOAD_CUSTOMER_PROFORMA:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_PROFORMA, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: false,
                    listing: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_PROFORMA, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.SET_CUSTOMER_INVOICES_FILTER:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                invoices: {
                    ...state.finance.invoices,
                    loading: true,
                    filters: {
                        ...state.finance.invoices.filters,
                        [action.key]: action.value,
                    },
                },
            }),
        });

    case CustomerTypes.RESET_CUSTOMER_INVOICES_FILTERS:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                invoices: {
                    ...state.finance.invoices,
                    filters: initState.finance.invoices.filters,
                },
            }),
        });

    case CustomerTypes.SET_CUSTOMER_INVOICES_PAGINATION:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                invoices: {
                    ...state.finance.invoices,
                    [action.key]: action.pagination,
                },
            }),
        });


    case CustomerTypes.SET_CUSTOMER_PROFORMA_FILTER:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: true,
                    filters: {
                        ...state.finance.proforma.filters,
                        [action.key]: action.value,
                    },
                },
            }),
        });

    case CustomerTypes.RESET_CUSTOMER_PROFORMA_FILTERS:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    filters: initState.finance.proforma.filters,
                },
            }),
        });

    case CustomerTypes.SET_CUSTOMER_PROFORMA_PAGINATION:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    [action.key]: action.pagination,
                },
            }),
        });

    case CustomerTypes.SET_CHECKED_CUSTOMER_PROFORMA:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    checked: action.ids,
                },
            }),
        });

    case CustomerTypes.SELECT_CUSTOMER_PROFORMA:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    selected: action.ids,
                },
            }),
        });

    case CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                billingAddresses: {
                    ...state.finance.billingAddresses,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                billingAddresses: {
                    ...state.finance.billingAddresses,
                    loading: false,
                    listing: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                billingAddresses: {
                    ...state.finance.billingAddresses,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.SET_EMPTY_BILLING_ADDRESS_FOR_FINANCE:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                billingAddresses: {
                    loading: false,
                    error: false,
                    listing: null,
                },
            }),
        });

    case CustomerTypes.LOAD_INVOICE_DETAILS:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                details: {
                    ...state.finance.details,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_INVOICE_DETAILS, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                details: {
                    ...state.finance.details,
                    loading: false,
                    listing: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_INVOICE_DETAILS, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                details: {
                    ...state.finance.details,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.LOAD_CUSTOMER_TURNOVER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit,
                turnover: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_TURNOVER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit,
                turnover: {
                    loading: false,
                    data2Months: action.data2Months,
                    dataTotal: action.dataTotal,
                },
            }),
        });

    case actionCreator(CustomerTypes.LOAD_CUSTOMER_TURNOVER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit,
                turnover: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.SET_EMPTY_CUSTOMER_TURNOVER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case CustomerTypes.DOWNLOAD_ALL_INVOICES:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                [action.invoiceType]: {
                    ...state.finance[action.invoiceType],
                    [action.invoiceAction]: {
                        loading: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(CustomerTypes.DOWNLOAD_ALL_INVOICES, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                [action.invoiceType]: {
                    ...state.finance[action.invoiceType],
                    [action.invoiceAction]: {
                        loading: action.loading,
                        error: false,
                        success: action.success,
                    },
                },
            }),
        });

    case actionCreator(CustomerTypes.DOWNLOAD_ALL_INVOICES, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                [action.invoiceType]: {
                    ...state.finance[action.invoiceType],
                    [action.invoiceAction]: {
                        loading: false,
                        error: action.error,
                    },
                },
            }),
        });

    case CustomerTypes.CREATE_GROUPED_INVOICE:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: true,
                },
            }),
        });

    case actionCreator(CustomerTypes.CREATE_GROUPED_INVOICE, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: false,
                    proforma_ids: action.data,
                },
            }),
        });

    case actionCreator(CustomerTypes.CREATE_GROUPED_INVOICE, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    loading: false,
                    error: true,
                },
            }),
        });

    case CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                setCreditNoteInvoice: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                setCreditNoteInvoice: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                setCreditNoteInvoice: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case CustomerTypes.REGENERATE_PROFORMA:
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    regenerate: {
                        ...state.finance.proforma.regenerate,
                        loading: [...state.finance.proforma.regenerate.loading, action.data.id],
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(CustomerTypes.REGENERATE_PROFORMA, 'res'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    regenerate: {
                        ...state.finance.proforma.regenerate,
                        loading: state.finance.proforma.regenerate.loading.filter(l => l !== action.id),
                    },
                },
            }),
        });

    case actionCreator(CustomerTypes.REGENERATE_PROFORMA, 'err'):
        return Object.assign({}, state, {
            finance: Object.assign({}, state.finance, {
                proforma: {
                    ...state.finance.proforma,
                    regenerate: {
                        ...state.finance.proforma.regenerate,
                        loading: [],
                        error: true,
                    },
                },
            }),
        });

    default:
        return state;
    }
}
